import React, { useState } from 'react';
import PhoneInputWithCountry from 'react-phone-number-input';
import { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  id: string;
  required?: boolean;
  placeholder?: string;
  onValidationChange?: (isValid: boolean) => void;
}
export const PhoneInput = ({
  value,
  onChange,
  id,
  required = false,
  placeholder = '+1 (555) 000-0000',
  onValidationChange
}: PhoneInputProps) => {
  const [touched, setTouched] = useState(false);
  const [error, setError] = useState<string>('');
  const validatePhone = (phoneValue: string) => {
    if (!phoneValue && required) {
      setError('Phone number is required');
      onValidationChange?.(false);
      return false;
    }
    if (phoneValue && !isValidPhoneNumber(phoneValue)) {
      setError('Please enter a valid phone number');
      onValidationChange?.(false);
      return false;
    }
    setError('');
    onValidationChange?.(true);
    return true;
  };
  const handleChange = (val: string | undefined) => {
    const newValue = val || '';
    onChange(newValue);
    // Only validate if field has been touched
    if (touched) {
      validatePhone(newValue);
    }
  };
  const handleBlur = () => {
    setTouched(true);
    validatePhone(value);
  };
  const hasError = touched && error;
  return <div className="w-full" data-id="element-409">
      <PhoneInputWithCountry international defaultCountry="US" value={value} onChange={handleChange} onBlur={handleBlur} id={id} required={required} placeholder={placeholder} className={`phone-input-wrapper ${hasError ? 'phone-input-error' : ''}`} numberInputProps={{
      className: `flex-1 px-4 py-2.5 rounded-r-lg border border-l-0 ${hasError ? 'border-red-300 focus:border-red-500 focus:ring-red-500/20' : 'border-gray-200 focus:border-[#d8a34d] focus:ring-[#d8a34d]/20'} focus:ring-2 outline-none transition-all text-gray-900 bg-gray-50/50 focus:bg-white`
    }} data-id="element-410" />
      {hasError && <p className="mt-1.5 text-sm text-red-600 flex items-center gap-1" data-id="element-411">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" data-id="element-412">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" data-id="element-413" />
          </svg>
          {error}
        </p>}
    </div>;
};